(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeDialogController', CustomRowTypeAttributeDialogController);

    CustomRowTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomRowTypeAttribute'];

    function CustomRowTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomRowTypeAttribute) {
        var vm = this;

        vm.customRowTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customrowtypeattributevalues = CustomRowTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customRowTypeAttribute.customRowTypeAttributeValues != null && vm.customRowTypeAttribute.customRowTypeAttributeValues.length != 0) {
			vm.items = vm.customRowTypeAttribute.customRowTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customRowTypeAttribute.id !== null) {
            	
            	 vm.customRowTypeAttribute.customRowTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRowTypeAttribute.customRowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomRowTypeAttribute.update(vm.customRowTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customRowTypeAttribute.customRowTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRowTypeAttribute.customRowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomRowTypeAttribute.save(vm.customRowTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customRowTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-row-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
